<section class="gallery-layout gallery-layout-11">
  <div class="container">
    <div class="row">
      <div class="col-lg-5 col-xs-12">
        @if (data().quote) {
          <app-quote [quote]="{ text: data().quote! }" class="quote" theme="BROWN" />
        }
      </div>
      @if (data().items[0]; as item) {
        <div class="col-lg-6 col-lg-offset-1 col-xs-12">
          <figure class="figure item-0">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dw: 600, dh: 441, mh: 245 }" class="img item-0" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
    </div>
    <div class="row">
      @if (data().items[1]; as item) {
        <div class="col-lg-5 col-xs-12">
          <figure class="figure item-1">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dw: 500, dh: 729, mh: 491 }" class="img item-1" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
      @if (data().items[2]; as item) {
        <div class="col-lg-4 col-lg-offset-2 col-xs-12">
          <figure class="figure item-2">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dw: 400, dh: 218, mh: 218 }" class="img" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
      <div class="col-lg-1"></div>
    </div>
  </div>
</section>
